import { ArrowLeftSmIcon, ArrowRightSmIcon, Button, Grid, styled, Typography, useTheme } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

interface PaginationProps {
  page: number
  limit: number
  total?: number
  onNexPage: (page: number) => void
  onPreviousPage: (page: number) => void
  loading?: boolean
}

const StyledButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  color: theme.palette.neutralGrey[1300],
  borderRadius: 7,
  '&:disabled': {
    backgroundColor: theme.palette.neutralGrey[400],
    borderColor: theme.palette.neutralGrey[400],
  },
}))

const ShopPagination = ({ page, limit, total, onPreviousPage, onNexPage, loading }: PaginationProps) => {
  const theme = useTheme()
  const translate = useTranslate()
  const hasTotal = total && total > 0

  const pageStart = page > 1 ? (page - 1) * limit : 1
  let pageEnd = pageStart + limit - 1
  pageEnd = hasTotal && pageEnd > total ? total : pageEnd

  return (
    <Grid container justify="space-between" alignContent="center" xs={12}>
      <Grid container item xs={6}>
        <Typography textVariant="body1" colorHex={theme.palette.neutralGrey[1000]} style={{ marginBlock: 'auto' }}>
          {!loading && (
            <>
              {translate('Showing %{pageStart} to %{pageEnd} of %{total}', { pageStart, pageEnd, total })}{' '}
              {total && total > 1 ? translate('results') : translate('result')}
            </>
          )}
        </Typography>
      </Grid>
      <Grid item container spacing={1} xs={6} justify="flex-end" alignContent="center" alignItems="center">
        <Grid item>
          <StyledButton
            size="medium"
            variant="outlined"
            disabled={loading || page <= 1}
            onClick={() => onPreviousPage(page - 1)}
          >
            <ArrowLeftSmIcon
              size={11}
              color={loading || page <= 1 ? theme.palette.neutralGrey[800] : theme.palette.neutralGrey[1300]}
            />
            <Typography
              textVariant="body1SemiBold"
              colorHex={loading || page <= 1 ? theme.palette.neutralGrey[800] : theme.palette.neutralGrey[1300]}
            >
              {translate('Previous')}
            </Typography>
          </StyledButton>
        </Grid>
        <Grid item>
          <StyledButton
            size="medium"
            variant="outlined"
            disabled={loading || pageEnd === total}
            onClick={() => onNexPage(page + 1)}
          >
            <Typography
              textVariant="body1SemiBold"
              colorHex={loading || pageEnd === total ? theme.palette.neutralGrey[800] : theme.palette.neutralGrey[1300]}
            >
              {translate('Next')}
            </Typography>
            <ArrowRightSmIcon
              size={11}
              color={loading || pageEnd === total ? theme.palette.neutralGrey[800] : theme.palette.neutralGrey[1300]}
            />
          </StyledButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ShopPagination
